import {
  ActivityPacing,
  ActivityType,
} from '@showbie-socrative/socrative-utils';

import { RoomTypes } from '~analytics/types';

import { sendPauseActivityEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface PauseActivityEventAdapterParams {
  settings: any;
  activityType: ActivityType | string;
  isRosteredRoom: boolean;
  numberStudents: number;
  numberResponses: number;
  startTime: string;
  actionType: 'pause' | 'resume';
}

export class PauseActivityEventAdapter extends EventAdapter {
  protected intercomEventKey = 'pause-activity';
  protected amplitudeEventFunction = sendPauseActivityEvent;

  constructor({
    settings,
    activityType,
    isRosteredRoom,
    numberStudents,
    numberResponses,
    startTime,
    actionType,
  }: PauseActivityEventAdapterParams) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      let deliveryMethod = 'instant_feedback';

      if (settings.pacing === ActivityPacing.Teacher)
        deliveryMethod = 'teacher_paced';
      if (settings.allowStudentNav) deliveryMethod = 'open_navigation';

      const quizTimerSeconds = settings.quizTimerSeconds ?? -1;
      const timerDuration = quizTimerSeconds === -1 ? null : quizTimerSeconds;

      this.eventData = {
        room_type: roomType,
        activity_type: activityType,
        delivery_method: deliveryMethod,
        activity_require_names: settings.requireNames,
        activity_shuffle_questions: settings.randomQuestions,
        activity_shuffle_answers: settings.randomAnswers,
        activity_show_question_feedback: settings.showFeedback,
        activity_show_final_score: settings.showResults,
        activity_one_attempt: settings.oneAttempt,
        activity_timer_duration_seconds: timerDuration,
        number_of_students: numberStudents,
        number_of_responses: numberResponses,
        start_time: startTime,
        action_type: actionType,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
